// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".docs-title h2[data-v-0c6bb04f]{color:#9BA3B6}.docs-title h2.sm[data-v-0c6bb04f]{font-size:18px}.docs-title h2.md[data-v-0c6bb04f]{font-size:22px}.docs-title h2.lg[data-v-0c6bb04f]{font-size:28px}.docs-title .desc[data-v-0c6bb04f]{color:#9BA3B6;font-size:14px;font-weight:normal;padding-top:4px}\n", ""]);
// Exports
module.exports = exports;
